export default __webpack_public_path__ + "static/media/R8.b667747b.JPG";